import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import userReducer from './user/user.reducer';
import loadingReducer from './loading/loading.reducer';
import infoReducer from './info/info.reducer';

const rootReducer = combineReducers({
  form: formReducer,
  user: userReducer,
  loading: loadingReducer,
  info: infoReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/rootReducer.js